import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import { welcomeActivityJsonSchema, welcomeActivityUiSchema } from '@/services/schema/activity'

const WelcomeActivitySetUp = ({formData, handleFormChange}) => {
  return (
    <>
      <JsonFormsWrapper
        jsonschema={welcomeActivityJsonSchema}
        uischema={welcomeActivityUiSchema}
        data={formData}
        onChange={handleFormChange}
      />
    </>
  )
}

export default WelcomeActivitySetUp